export default function WaterHeater() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10719_11780)">
                <path
                    d="M17.5 5H7.5C6.67157 5 6 5.67157 6 6.5V23.5C6 24.3284 6.67157 25 7.5 25H17.5C18.3284 25 19 24.3284 19 23.5V6.5C19 5.67157 18.3284 5 17.5 5Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 15H10.5C9.67157 15 9 15.6716 9 16.5V22H16V16.5C16 15.6716 15.3284 15 14.5 15Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 22H19" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 25L9 28" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M16 25V25.5C16 27.1569 17.3431 28.5 19 28.5H21C22.6569 28.5 24 27.1569 24 25.5V16"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M23 9.5L23 10.5C23 11.3284 23.6716 12 24.5 12L28 12L28 8L24.5 8C23.6716 8 23 8.67157 23 9.5Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23 10.5L23 14.5C23 15.3284 23.6716 16 24.5 16V16C25.3284 16 26 15.3284 26 14.5L26 12"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_10719_11780">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
